import { Component, OnInit } from '@angular/core';
import { StepSharedService } from '../stepshared.service';
import { TosterService } from 'src/app/core/services/toster/toster.service';
import { SettingsService } from 'src/app/core/services/http/settings.service';
import { StripeCardView } from 'src/app/settings/models/stripe-card-view';
import { environment } from 'src/environments/environment';
import { UserSessionService } from 'bna-angular-auth-client';

@Component({
  selector: 'app-onboarding-step-three-component',
  templateUrl: './onboarding-step-three-component.component.html',
  styleUrls: ['./onboarding-step-three-component.component.scss'],
})
export class OnboardingStepThreeComponentComponent implements OnInit {
  cardDetails: StripeCardView[];
  publishableKey: string;
  cardTemplate: any;
  stripe: any;
  isCardAdding: boolean;
  canFinishOnboarding: boolean = false;
  hasError: boolean = false;
  public readonly maintenanceAppUrl: string;

  constructor(
    private sharedService: StepSharedService,
    private toasterService: TosterService,
    private settingsService: SettingsService,
    public userSessionService: UserSessionService,
  ) {
    this.maintenanceAppUrl = this.userSessionService.addSessionQueryParams(
      `${environment.maintenanceApp.baseUrl}`
    );
  }

  ngOnInit(): void {
    this.getCardDetails();
  }

  next() {
    this.onSubmitAddNewCard();
  }
  back() {
    const nextStep = 2;
    this.sharedService.changeStep(nextStep);
  }

  getCardDetails() {
    this.settingsService.getCardDetails().subscribe({
      next: (res) => {
        this.publishableKey = res.publishableKey;
        this.cardDetails = res.cardDetails;
        if (res.cardDetails.length > 0) {
          this.mapWithBrandImage();
        }
        this.getInitialData();
        this.getStripeTemplate();
      },
      error: (error) => {
        this.toasterService.error(error);
      },
    });
  }

  mapWithBrandImage() {
    this.cardDetails.map((card) => {
      switch (card.brand) {
        case 'Visa':
          card.brandImage =
            '../../../../assets/images/key-automate/visa_logo.png';
          break;
        case 'MasterCard':
          card.brandImage =
            '../../../../assets/images/key-automate/master_logo.png';
          break;
        case 'American Express':
          card.brandImage =
            '../../../../assets/images/key-automate/amex_logo.png';
          break;
      }
    });
  }

  getStripeTemplate() {
    this.cardTemplate.mount('#card-element');
    this.cardTemplate.clear();
    this.cardTemplate.addEventListener('change', function (event) {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        if (event.error.message == 'Your card number is invalid.') {
          displayError.textContent = 'Invalid card number.';
        } else {
          displayError.textContent = event.error.message;
        }
        this.hasError = true;
      } else {
        displayError.textContent = '';
        this.hasError = false;
      }
    });
  }

  getInitialData() {
    this.stripe = window['Stripe'](this.publishableKey);
    const elements = this.stripe.elements();
    const style = {
      base: {
        color: '#000',
        lineHeight: '18px',
        fontFamily: 'Poppins',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    };
    this.cardTemplate = elements.create('card', {
      style: style,
      hidePostalCode: true,
    });
  }

  onSubmitAddNewCard() {
    this.isCardAdding = true;
    document.getElementById('card-errors').textContent = '';
    const _self = this;
    this.stripe.createToken(this.cardTemplate).then(function (result) {
      if (result.error) {
        var errorElement = document.getElementById('card-errors');
        errorElement.textContent = result.error.message;
        _self.isCardAdding = false;
      } else {
        const formData = {
          cardToken: result.token.id,
          IsOnboarding: true,
        };
        _self.settingsService.addCard(formData).subscribe({
          next: (result) => {
            if (result.isSuccess) {
              _self.getStripeTemplate();
              _self.addSystemActivationDetails();
              _self.saveIsKeyAutomateFirstLogging();
              _self.sharedService.changeStep(4);
              _self.sendData();
              _self.toasterService.success('New card is added successfully!');
            } else {
              var errorElement = document.getElementById('card-errors');
              errorElement.textContent = result.error;
            }
            _self.isCardAdding = false;
          },
          error: (error) => {
            _self.toasterService.error('Failed to add the card!');
            _self.isCardAdding = false;
          },
        });
      }
    });
  }
  addSystemActivationDetails() {
    this.settingsService.systemActivationDetails().subscribe({
      next: (result) => {},
      error: (error) => {},
    });
  }

  select(isChecked) {
    if (isChecked) {
      this.canFinishOnboarding = true;
    } else {
      this.canFinishOnboarding = false;
    }
  }
  saveIsKeyAutomateFirstLogging() {
    const formData = {
      IsKeyAutomateFirstLogging: true,
    };
    this.settingsService.IsKeyAutomateFirstLogging(formData).subscribe({
      next: (result) => {},
      error: (error) => {},
    });
  }

  sendData() {
    this.sharedService.sendData(true);
  }
}
